import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Routes, Route } from 'react-router-dom';

import { requestViewAllProgrammes } from '../../api/programme/programme.actions';

import HomeContainer from './home/Home.container';
import GeneralContainer from './general/General.container';
import PlanContainer from './plan/Plan.container';
import AccountabilityContainer from './accountability/Accountability.container';
import SupportContainer from './support/Support.container';
import SupportChatContainer from './support/support-chat/SupportChat.container';
import TribeContainer from './tribe/Tribe.container';
import TribeApprovalsContainer from './tribe/tribe-approvals/TribeApprovals.container';
import TribeMemberEngagementContainer from './tribe/tribe-member-engagement/TribeMemberEngagement.container';

const ProgrammeContainer = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(requestViewAllProgrammes({}));
  }, [dispatch]);

  return (
    <Routes>
      <Route path="/" element={<HomeContainer />} />
      <Route path="/:status/general" element={<GeneralContainer />} />
      <Route path="/:status/:programmeExternalReference/general/:view" element={<GeneralContainer />} />
      <Route
        path="/:status/:programmeExternalReference/general/:view/:teamExternalReference"
        element={<GeneralContainer />}
      />
      <Route path="/:status/:programmeExternalReference/plan" element={<PlanContainer />} />
      <Route path="/:status/:programmeExternalReference/accountability/:view" element={<AccountabilityContainer />} />
      <Route path="/:status/:programmeExternalReference/support" element={<SupportContainer />} />
      <Route
        path="/:status/:programmeExternalReference/support/:systemUserExternalReference"
        element={<SupportChatContainer />}
      />
      <Route path="/:status/:programmeExternalReference/tribe" element={<TribeContainer />} />
      <Route path="/:status/:programmeExternalReference/tribe/approvals" element={<TribeApprovalsContainer />} />
      <Route path="/:status/:programmeExternalReference/tribe/:memberExternalReference" element={<TribeContainer />} />
      <Route
        path="/:status/:programmeExternalReference/tribe/member-engagement"
        element={<TribeMemberEngagementContainer />}
      />
    </Routes>
  );
};

export default ProgrammeContainer;
